import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import loadable from "./loadable";

const Routes = () => (
  <BrowserRouter>
    <Route path="/help" component={loadable(() => import("../pages/help/index"))} />
    <Route path="/" component={loadable(() => import("../pages/index"))} />
  </BrowserRouter>
);

export default Routes;
